"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shoppingBagReducer = exports.shoppingBagInitialState = exports.ShoppingBagActionTypes = void 0;
/**
 * Shopping Bag actions types
 */
var ShoppingBagActionTypes;
(function (ShoppingBagActionTypes) {
    ShoppingBagActionTypes["OPEN_POPOVER"] = "OPEN_POPOVER";
    ShoppingBagActionTypes["CLOSE_POPOVER"] = "CLOSE_POPOVER";
    ShoppingBagActionTypes["OPEN_BAG"] = "OPEN_BAG";
    ShoppingBagActionTypes["CLOSE_BAG"] = "CLOSE_BAG";
})(ShoppingBagActionTypes = exports.ShoppingBagActionTypes || (exports.ShoppingBagActionTypes = {}));
exports.shoppingBagInitialState = {
    isPopoverOpen: false,
    isOpen: false,
};
const shoppingBagReducer = (state = exports.shoppingBagInitialState, action) => {
    switch (action.type) {
        case ShoppingBagActionTypes.OPEN_POPOVER:
            return Object.assign(Object.assign({}, state), { isPopoverOpen: true });
        case ShoppingBagActionTypes.CLOSE_POPOVER:
            return Object.assign(Object.assign({}, state), { isPopoverOpen: false });
        case ShoppingBagActionTypes.OPEN_BAG:
            return Object.assign(Object.assign({}, state), { isOpen: true });
        case ShoppingBagActionTypes.CLOSE_BAG:
            return Object.assign(Object.assign({}, state), { isOpen: false });
        default:
            return state;
    }
};
exports.shoppingBagReducer = shoppingBagReducer;
